import { defaultEvent, Event } from './Event';

export interface EventProgram {
    id: number;
    title: string;
    start_date: string;
    end_date: string;
    start_hour: string;
    end_hour: string;
    event_id: number;
    event?: Event;
    is_active: boolean;
}

export const defaultEventProgram: EventProgram = {
    end_date: '',
    end_hour: '',
    start_date: '',
    start_hour: '',
    event_id: 0,
    title: '',
    id: 0,
    is_active: true
};

export interface EventProgramFilters {
    title?: string | null;
    page: number;
    per_page: number;
    sort: string;
    order: string;
}
